import React from 'react';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { Label } from '../ui/label';

// Tailwind needs literal class strings to scan — map tint → full class set.
const TINT_CLASSES = {
  emerald: 'mt-1.5 border-slate-200 focus:border-emerald-500 focus:ring-emerald-500',
  amber: 'mt-1.5 border-slate-200 focus:border-amber-500 focus:ring-amber-500',
};

const FormField = ({
  id, label, type = 'text', value, onChange,
  required = false, placeholder = '', rows, tint = 'emerald',
}) => {
  const inputClass = TINT_CLASSES[tint] || TINT_CLASSES.emerald;
  const isTextarea = type === 'textarea';
  return (
    <div>
      <Label htmlFor={id} className="text-slate-700">{label}</Label>
      {isTextarea ? (
        <Textarea
          id={id}
          rows={rows || 4}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={`${inputClass} resize-none`}
        />
      ) : (
        <Input
          id={id}
          type={type}
          required={required}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={inputClass}
        />
      )}
    </div>
  );
};

export default FormField;
